import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { environment } from 'src/environments/environment'


const { apiUrl } = environment

export interface PaymentOriginator {
  payment_originator_id: string
  user_id: string
  created: number
  updated: number
  archived?: number
  bank: 'hsbc' | 'rbc'
  purpose: 'cross_border' | 'eft'
  currency: 'CAD' | 'USD'
  client_id?: string
  account_number?: string
  originator_id?: string
  return_fi?: string
  return_account?: string
  is_test: boolean
  ranking?: number
}


@Injectable()
export class PaymentOriginatorApiService {
  private http = inject(HttpClient)


  list(params?) {
    return this.http.get<{ data: PaymentOriginator[] }>(`${apiUrl}/payment-originator`, { params }).toPromise()
  }

  get(id: string) {
    return this.http.get<{ data: PaymentOriginator }>(`${apiUrl}/payment-originator/${id}`).toPromise()
  }
}
